<div class="page-container">
  <div class="accept-card scrollable-content">
    <!-- Loading state -->
    @if (state() === 'loading') {
    <div class="state-content" data-testid="loading-state">
      <div class="spinner"></div>
      <h2>{{ 'auth.invitation.loading' | translate }}</h2>
      <p>{{ 'auth.invitation.loadingMessage' | translate }}</p>
    </div>
    }


    <!-- Preview state - Show invitation details -->
    @if (state() === 'preview' && invitation()) {
    <div class="state-content preview" data-testid="preview-state">
      <div class="invitation-icon">
        <app-icon name="mail" [size]="48" />
      </div>

      <h1>{{ 'auth.invitation.youreInvited' | translate }}</h1>

      <div class="invitation-details">
        <p class="inviter-message">
          {{ 'auth.invitation.inviterMessage' | translate:{ inviterName: invitation()!.inviterName } }}
        </p>
        <p class="organization-name">{{ invitation()!.organizationName }}</p>
        <p class="role-info">{{ 'auth.invitation.roleInfo' | translate:{ role: invitation()!.role } }}</p>
      </div>

      <div class="info-section">
        <div class="info-header">
          <app-icon name="info" [size]="20" />
          <h3>{{ 'auth.invitation.whatHappens' | translate }}</h3>
        </div>
        <ol class="steps-list">
          <li>{{ 'auth.invitation.step1' | translate }}</li>
          <li>{{ 'auth.invitation.step2' | translate }}</li>
          <li>{{ 'auth.invitation.step3' | translate:{ organizationName: invitation()!.organizationName } }}</li>
        </ol>
      </div>

      <div class="privacy-section">
        <div class="privacy-header">
          <app-icon name="shield" [size]="20" />
          <h3>{{ 'auth.invitation.privacyTitle' | translate }}</h3>
        </div>
        <div class="privacy-details">
          <p>{{ 'auth.invitation.whyGoogle' | translate }}</p>

          <p><strong>{{ 'auth.invitation.dataReceivedTitle' | translate }}</strong></p>
          <ul>
            <li>{{ 'auth.invitation.dataReceived.name' | translate }}</li>
            <li>{{ 'auth.invitation.dataReceived.email' | translate }}</li>
            <li>{{ 'auth.invitation.dataReceived.photo' | translate }}</li>
          </ul>

          <p>{{ 'auth.invitation.googleCannotSee' | translate }}</p>
        </div>
      </div>

      <div class="actions">
        <app-button variant="outlined" (click)="decline()">
          {{ 'auth.invitation.decline' | translate }}
        </app-button>
        <app-button color="primary" (click)="acceptWithGoogle()">
          <app-icon name="log-in" />
          {{ 'auth.invitation.continueWithGoogle' | translate }}
        </app-button>
      </div>

      <!-- Test auth option (development only) -->
      @if (invitation()!.email.endsWith('@test.com')) {
      <div class="test-auth-divider">
        <span>or for testing</span>
      </div>
      <app-button color="accent" (click)="acceptWithTestAuth()" class="test-auth-button">
        {{ 'auth.invitation.continueWithTestAuth' | translate }}
      </app-button>
      }

      <p class="expires-note">{{ 'auth.invitation.expiresIn' | translate:{ timeRemaining:
        getTimeRemaining(invitation()!.expiresAt) } }}</p>
    </div>
    }

    <!-- Accepting state -->
    @if (state() === 'accepting') {
    <div class="state-content" data-testid="accepting-state">
      <div class="spinner"></div>
      <h2>{{ 'auth.invitation.accepting' | translate }}</h2>
      <p>{{ 'auth.invitation.acceptingMessage' | translate }}</p>
    </div>
    }

    <!-- Success state -->
    @if (state() === 'success') {
    <div class="state-content success" data-testid="success-state">
      <div class="success-icon">
        <app-icon name="circle-check-big" [size]="64" />
      </div>
      <h2>{{ 'auth.invitation.success' | translate }}</h2>
      <p>{{ 'auth.invitation.successMessage' | translate }}</p>
      <p class="redirect-message">{{ 'auth.invitation.redirecting' | translate }}</p>
    </div>
    }

    <!-- Error state -->
    @if (state() === 'error') {
    <div class="state-content error" data-testid="error-state">
      <div class="error-icon">
        <app-icon name="circle-alert" [size]="64" />
      </div>
      <h2>{{ 'auth.invitation.error' | translate }}</h2>
      <p>{{ errorMessage() }}</p>
      <app-button variant="outlined" (click)="decline()">
        {{ 'auth.invitation.returnHome' | translate }}
      </app-button>
    </div>
    }
  </div>
</div>